import { createApi } from "@reduxjs/toolkit/query/react";
import customBaseQuery from "@lxp-app/utils/customBaseQuery";

export const RemarksApi = createApi({
  reducerPath: "RemarksApi",

  baseQuery: customBaseQuery,

  endpoints: (builder) => ({
    getRemarks: builder.query({
      query: (contentId) => {
        return {
          url: `/utility/get/${contentId}`,
          method: "GET"
        };
      },
      extraOptions: { service: "Utility" }
    })
  })
});

export const { useLazyGetRemarksQuery } = RemarksApi;
export default RemarksApi;
